function DealService($q, BBModel) {
    'ngInject';

    return {
        query(company) {
            const deferred = $q.defer();
            if (!company.$has('deals')) {
                deferred.reject('No Deals found');
            } else {
                company.$get('deals').then((resource) => {
                        return resource.$get('deals').then((deals) => {
                                deals = (Array.from(deals).map(deal => new BBModel.Deal(deal)));
                                return deferred.resolve(deals);
                            }
                        );
                    }
                    , (err) => {
                        return deferred.reject(err);
                    }
                );
            }
            return deferred.promise;
        }
    };
}

angular
    .module('BB')
    .service('DealService', DealService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/deal.service.js